exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/src/app/create-agency/top-up/top-up.component.css
// module id = ../../../../../src/app/create-agency/top-up/top-up.component.css
// module chunks = 1